import React from 'react';

// Insignia de los turnos de reingreso (el cliente ya estuvo hoy en el estudio). Se muestra en el
// panel diario, la cola de atención y el turnero; con prioridad va en color lleno para que se vea
// de lejos por qué ese turno está primero en la cola.
//
// El trámite exprés (V249) tiene su propia insignia, azul: puede no ser un reingreso (cliente sin
// turno previo) y lo que importa es que solo entregó o retiró documentación.
function BadgeReingreso({ turno, className = '' }) {
    if (turno?.esTramiteExpres) {
        return (
            <span
                className={`rec-badge-expres ${className}`.trim()}
                title="Trámite exprés: solo entregó o retiró documentación"
            >
                <i className="bi bi-lightning-charge-fill me-1"></i>
                Trámite exprés
            </span>
        );
    }
    if (!turno?.esReingreso) return null;
    const prioridad = !!turno.prioridadReingreso;
    return (
        <span
            className={`rec-badge-reingreso ${prioridad ? 'rec-badge-reingreso--prioridad' : ''} ${className}`.trim()}
            title="Volvió al estudio después de una atención ya finalizada"
        >
            <i className="bi bi-arrow-repeat me-1"></i>
            {prioridad ? 'Reingreso · Prioridad' : 'Reingreso'}
        </span>
    );
}

export default BadgeReingreso;
